interface TrendBadgeProps {
  value: number;
  direction: "up" | "down" | "flat";
  suffix?: string;
  tone?: "auto" | "neutral";
  className?: string;
}

export default function TrendBadge({
  value,
  direction,
  suffix = "%",
  tone = "auto",
  className = "",
}: TrendBadgeProps) {
  const isUp = direction === "up";
  const isDown = direction === "down";

  const toneClass =
    tone === "neutral"
      ? "bg-background-100 text-foreground-600"
      : isUp
        ? "bg-primary-50 text-primary-700"
        : isDown
          ? "bg-red-50 text-red-600"
          : "bg-background-100 text-foreground-500";

  const icon = isUp
    ? "ri-arrow-up-line"
    : isDown
      ? "ri-arrow-down-line"
      : "ri-subtract-line";

  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${toneClass} ${className}`}
    >
      <span className="w-3 h-3 flex items-center justify-center">
        <i className={icon}></i>
      </span>
      {value}
      {suffix}
    </span>
  );
}